import "../stylesheets/application.tailwind.css"
import Swal from "sweetalert2/dist/sweetalert2.js";
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "../channels";
import '../images/NinjaFetch_Logo.png';
import '../images/ninja-to-rescue2.png';

window.Swal = Swal;
Rails.start();
Turbolinks.start();
ActiveStorage.start();
